import clsx from 'clsx';
import Image from 'next/image';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import ALL_STOCK_ICONS from '../../../public/stockIcons/stockIconSvg';
import { useState, useEffect } from 'react';

interface IAssetImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
}

// TO-DO
// NEED TO UPDATE TO
// MATCH THE BLOOM MOBILE SITUATION
// WHERE WE CAN CONVERT STOCK NAMES, ETC
// RN WE HAVE NO LOCAL VERSION OF STOCK DATA

function StockImage({
  src,
  alt,
  width = 45,
  height = 45,
  className
}: IAssetImageProps) {
  const placeholder = (
    <div className={twMerge(clsx('size-12 bg-gray-700 flex items-center justify-center', className, 'rounded-full'))} >
      <h4 className='uppercase text-white text-sm -mb-0.5'>{alt?.slice(0, Math.min(2, alt.length))}</h4>
    </div>
  );
  
  const [content, setContent] = useState<JSX.Element | null>(placeholder);
  
  useEffect(() => {
    if (!src) return;
    
    // Reset to placeholder when src changes to avoid showing old image
    setContent(placeholder);

    fetch(src)
      .then(response => {
        if (response.status >= 300) {
          setContent(placeholder);
        } else {
          setContent(
            <Image
              alt={alt}
              src={src}
              className={twMerge(clsx('flex-shrink-0 object-cover object-center bg-white', className, 'rounded-full'))}
              width={width}
              height={height}
              priority={true}
            />
          );
        }
      })
      .catch(error => {
        setContent(placeholder);
      });
  }, [src, alt, className, width, height]);

  return content;
}

function AssetImage({
  src,
  alt,
  width = 48,
  height = 48,
  className = 'size-12',
}: IAssetImageProps) {
  const SvgIcon = ALL_STOCK_ICONS[`${alt}Icon` as keyof typeof ALL_STOCK_ICONS];
  if (SvgIcon) {
    return (
      <Image
        alt={alt}
        src={SvgIcon.src}
        className={twMerge(
          clsx('flex-shrink-0 object-cover object-center', className, 'rounded-full')
        )}
        width={SvgIcon.width}
        height={SvgIcon.height}
        priority={true}
      />
    )
  }

  if (!src) {
    return (
      <div className={twMerge(clsx('bg-white flex items-center justify-center uppercase', className, 'rounded-full'))}>
        <h4 className='uppercase text-white text-sm -mb-0.5'>{alt?.slice(0, Math.min(2, alt.length))}</h4>
      </div>
    );
  }
 
  return (
    <StockImage src={src} alt={alt} width={width} height={height} className={className} />
  )
}

export default AssetImage;
